export const LINE_CDN_HOSTS = new Set([
  "profile.line-scdn.net",
  "obs.line-apps.com",
  "sprofile.line-scdn.net",
]);

// LINE CDN URLs are short paths; 2 048 chars is well above any real URL and
// prevents a malicious/misconfigured profile from inflating the KV session entry.
export const MAX_PICTURE_URL_LENGTH = 2048;

export function sanitizePictureUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;
  if (url.length > MAX_PICTURE_URL_LENGTH) return undefined;
  try {
    const { protocol, host } = new URL(url);
    return protocol === "https:" && LINE_CDN_HOSTS.has(host) ? url : undefined;
  } catch {
    return undefined;
  }
}

export function isSafePictureUrl(url: string | undefined): url is string {
  return sanitizePictureUrl(url) !== undefined;
}
